import { useMutation, useQuery } from "@tanstack/react-query";
import { AccountSettingService } from "../services/accountSetting.service";
import { SetAccountSettingValuePayload } from "../domain/accountSetting.interface";

export const useAccountSettings = (enabled = true) => {
  const {
    data: accountSettings,
    isLoading: isLoadingAccountSettings,
    isFetching: isFetchingAccountSettings,
    refetch: refetchAccountSettings,
  } = useQuery({
    queryKey: ["parca-account-settings-list"],
    queryFn: () => AccountSettingService.findAll(),
    enabled,
  });

  return {
    accountSettings,
    isLoadingAccountSettings,
    isFetchingAccountSettings,
    refetchAccountSettings,
  };
};

export const useSetAccountSettingValue = () => {
  return useMutation({
    mutationFn: ({
      settingId,
      payload,
    }: {
      settingId: string;
      payload: SetAccountSettingValuePayload;
    }) => AccountSettingService.setValueBySetting({ settingId, payload }),
  });
};

export const useArchiveAccountSetting = () => {
  return useMutation({
    mutationFn: (id: string) => AccountSettingService.archiveOne(id),
  });
};
